import {
  PIPEFITTER_SET_SEQUENCE_LIST,
  PIPEFITTER_SET_SEQUENCE_LOADING,
  PIPEFITTER_SET_SEQUENCE_LOADING_MORE,
} from './types';

const initialState = {
  sequenceList: [],
  sequenceTotalCount: null,
  sequenceLoadingMore: false,
  sequenceFetchComplete: false,
  isSequenceLoading: false,
};

export default function pipefitterSequenceReducer(state = initialState, action) {
  switch (action.type) {
    case PIPEFITTER_SET_SEQUENCE_LIST: {
      const p = action.payload;
      if (Array.isArray(p)) {
        return {
          ...state,
          sequenceList: p,
          sequenceTotalCount: p.length,
          sequenceLoadingMore: false,
          sequenceFetchComplete: true,
        };
      }
      if (p?.append) {
        const incoming = Array.isArray(p?.data) ? p.data : [];
        const totalCount =
          p?.totalCount != null && p.totalCount !== '' ? Number(p.totalCount) : state.sequenceTotalCount;
        return {
          ...state,
          sequenceList: [...state.sequenceList, ...incoming],
          sequenceTotalCount: Number.isFinite(totalCount) ? totalCount : state.sequenceTotalCount,
          sequenceLoadingMore: p?.loadingMore === true,
          sequenceFetchComplete: p?.fetchComplete === true,
        };
      }
      const list = Array.isArray(p?.data) ? p.data : [];
      const totalCount = p?.totalCount != null && p.totalCount !== '' ? Number(p.totalCount) : null;
      return {
        ...state,
        sequenceList: list,
        sequenceTotalCount: Number.isFinite(totalCount) ? totalCount : null,
        sequenceLoadingMore: p?.loadingMore === true,
        sequenceFetchComplete: p?.fetchComplete === true,
      };
    }
    case PIPEFITTER_SET_SEQUENCE_LOADING:
      return { ...state, isSequenceLoading: action.payload };
    case PIPEFITTER_SET_SEQUENCE_LOADING_MORE:
      return { ...state, sequenceLoadingMore: Boolean(action.payload) };
    default:
      return state;
  }
}
